import React from 'react';
import './Story.scss';
import storyImg from '../../assets/img/storyImg.png'
function Story({t}) {
  return (

    <div className="story-content-wrapper">
        <div className="story">
            <div className="story-content">
                <div className="story-img">
                    <img src={storyImg} alt="story"/>
                </div>
                <div className="story-text">
                    <div className="story-capture">
                        {t("story_capture")}
                    </div>
                    <p>
                        {t("story_description1")}
                    </p>
                    <p>
                        {t("story_description2")}
                    </p>

                </div>
            </div>
        </div>
    </div>     

  );
}

export default Story;